<template>
  <v-dialog :value="dialog" scrollable :max-width="maxWidth">
    <v-card v-if="target" min-height="300">
      <div class="d-flex align-center">
        <div class="font-weight-bold ml-3 grey--text text--darken-2">
          {{ target.id }}
        </div>
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-text v-if="target !== null" class="px-3">
        <v-row dense no-gutters>
          <v-col cols="4" style="max-width: 140px">
            カテゴリ
          </v-col>
          <v-col cols="8" class="grey--text text--darken-4">
            {{ target.category }}
          </v-col>
          <v-col cols="4" style="max-width: 140px">
            情報種別
          </v-col>
          <v-col cols="8" class="grey--text text--darken-4">
            {{ target.section }}
          </v-col>
          <v-col cols="4" style="max-width: 140px">
            発生/確認日時
          </v-col>
          <v-col cols="8" class="grey--text text--darken-4">
            {{ target.jst }}
          </v-col>
        </v-row>
        <div class="d-flex">
          <v-spacer />
          <v-btn small @click="appendProgress">追加</v-btn>
        </div>

        <v-list dense>
          <div v-for="(row, index) in progresses" :key="index">
            <v-divider></v-divider>
            <v-list-item
              @click="showProgressEditor(row)"
              dense
              :style="index % 2 === 0 ? { 'background-color': '#F5F5F5' } : {}"
            >
              <v-list-item-content class="chronology-detail-list-item">
                <v-list-item-title class="font-weight-bold">
                  {{ row.jst }}
                </v-list-item-title>
                <div class="d-flex">
                  <div>
                    {{ row.progress }}
                  </div>
                  <v-spacer />
                  <div v-if="row.files.length > 0" class="px-2">
                    <v-badge
                      color="#FFB74D"
                      :content="row.files.length"
                      overlap
                    >
                      <v-card
                        max-width="100"
                        max-height="100"
                        flat
                        v-if="row.imageUrl"
                      >
                        <v-img :src="row.imageUrl" contain />
                      </v-card>
                      <v-icon v-else color="grey lighten-1">
                        mdi-paperclip
                      </v-icon>
                    </v-badge>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
      </v-card-text>
    </v-card>
    <ChronologyProgress
      :dialog="progressDialog"
      :data="progressRow"
      @close="handlerCloseProgressEditor"
    />
  </v-dialog>
</template>
<script>
import moment from "moment";
import ChronologyProgress from "./ChronologyProgress";
import chronologyAPI from "../../utils/chronologyAPI";
export default {
  name: "ChronologyDetail",

  components: {
    ChronologyProgress
  },

  props: {
    dialog: Boolean,
    data: Object,
    maxWidth: {
      type: [String, Number],
      default: 500
    }
  },

  data() {
    return {
      target: null,
      progresses: [],
      progressDialog: false,
      progressRow: null
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    dialog(val) {
      if (!val) return;
      this.progresses = [];
      this.target = { ...this.data };
      this.target.jst = moment
        .utc(this.target.date, "YYYYMMDDHHmm")
        .local()
        .format("YYYY/MM/DD HH:mm");
      this.fetchProgresses();
    }
  },

  methods: {
    openUrl() {
      if (!this.target.s3_url) return;
      window.open(this.target.s3_url, "_blank");
    },

    async fetchProgresses() {
      if (!this.target || !this.target.id) return;
      const params = {
        chronologyId: this.target.id
      };
      const reponse = await chronologyAPI.get("/progress", params);
      if (reponse && reponse.progresses) {
        this.progresses = reponse.progresses.map(progress => {
          progress.jst = moment
            .utc(progress.date, "YYYYMMDDHHmm")
            .local()
            .format("YYYY/MM/DD HH:mm");
          const imageKey = progress.files.find(
            s3Key =>
              s3Key.endsWith(".jpg") ||
              s3Key.endsWith(".jpeg") ||
              s3Key.endsWith(".png")
          );
          if (imageKey) {
            progress.imageUrl = `https://hodatsushimizu-chronology.riskma.jp/${imageKey}`;
          }
          return progress;
        });
      } else {
        this.progresses = [];
      }
    },

    appendProgress() {
      this.progressRow = {
        hash: `${this.target.hash}-${this.target.id}`,
        id: 0,
        chronologyId: this.target.id,
        user: ""
      };
      this.progressDialog = true;
    },

    showProgressEditor(row) {
      this.progressRow = row;
      this.progressDialog = true;
    },

    handlerCloseProgressEditor() {
      this.progressDialog = false;
      this.fetchProgresses();
    }
  }
};
</script>
<style lang="scss" scoped>
.chronology-detail-list-item {
  font-size: 14px !important;
  @media screen and (min-width: 900px) {
    font-size: 16px !important;
  }
}
</style>
